import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from './api';
import { STORES_API_BASE } from './useStores';

export type LoyaltySummary = {
  members_total: number;
  members_active_12m: number;
  synced_at: string;
};

export type SignupMonth = {
  month: string;
  signups: number;
};

export type TopCustomer = {
  rank: number;
  display_name: string;
  points_balance: number;
};

// Store-attributed activity on the shared program (issue #410): points earned/
// redeemed and member-attach rate for a period. attach_rate is member_tickets /
// total_tickets in [0,1], or null when the store had no tickets in the period.
export type LoyaltyActivityPeriod = {
  points_earned: number;
  points_redeemed: number;
  member_tickets: number;
  total_tickets: number;
  attach_rate: number | null;
};

export type LoyaltyPeriodActivity = {
  month: LoyaltyActivityPeriod;
  year: LoyaltyActivityPeriod;
};

export type LoyaltyData = {
  summary: LoyaltySummary;
  signups_monthly: SignupMonth[];
  top_customers: TopCustomer[];
  period_activity: LoyaltyPeriodActivity;
};

export function useLoyalty(storeNo?: number): UseQueryResult<LoyaltyData, Error> {
  const qs = storeNo !== undefined ? `?store_no=${storeNo}` : '';
  return useQuery<LoyaltyData, Error>({
    queryKey: ['stores', 'loyalty', storeNo ?? 'own'],
    queryFn: () => apiGet<LoyaltyData>(`${STORES_API_BASE}/loyalty${qs}`),
    staleTime: 60_000,
    retry: false,
  });
}
